import { VERSION } from "./lib/utils/version.js";
import { parseWKT } from "./lib/parse-wkt.js";
import { isWKT, WKT_MAGIC_STRINGS } from "./lib/parse-wkt.js";
export const WKTWorkerLoader = {
  name: 'WKT (Well-Known Text)',
  id: 'wkt',
  module: 'wkt',
  version: VERSION,
  worker: true,
  extensions: ['wkt'],
  mimeTypes: ['text/plain'],
  category: 'geometry',
  text: true,
  tests: WKT_MAGIC_STRINGS,
  testText: isWKT,
  options: {
    wkt: {
      shape: 'geojson-geometry',
      crs: true
    }
  }
};
export const WKTLoader = {
  ...WKTWorkerLoader,
  parse: async (arrayBuffer, options) => parseWKT(new TextDecoder().decode(arrayBuffer), options),
  parseTextSync: parseWKT
};
//# sourceMappingURL=wkt-loader.js.map